// extracted by mini-css-extract-plugin
export var cmtSCardHorizontal = "styles-module--cmt-s-card-horizontal--66b6f";
export var cmtSCardHorizontal__container = "styles-module--cmt-s-card-horizontal__container--f87d4";
export var cmtSCardHorizontal__lockup = "styles-module--cmt-s-card-horizontal__lockup--c3242";